var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6cc3c58cd43579a603fac09c7ec188ae4f635f92"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["biproxi-web@biproxi"]={id:"6cc3c58cd43579a603fac09c7ec188ae4f635f92"};
      